import Vue from 'vue';

const GetHourDifference = {
  install(): void {
    Vue.prototype.getHourDifference = (start: string, end: string): string => {
      const startTimestamp = Math.floor(new Date(start).getTime() / 1000);
      const endTimestamp = Math.floor(new Date(end).getTime() / 1000);

      let difference = Math.abs(endTimestamp - startTimestamp);

      const hours = Math.floor(difference / 3600) % 24;
      difference -= hours * 3600;

      const minutes = Math.floor(difference / 60) % 60;
      difference -= minutes * 60;

      const seconds = difference % 60;

      return `${hours}h ${minutes}m ${seconds}s`;
    };
  },
};

export default GetHourDifference;
